import React from 'react';
import QueryModes from '../../search/QueryModes';

const SORT_OPTIONS = [
  { id: 'last_updated', label: 'last_updated' },
  { id: 'market_cap', label: 'market_cap' },
  { id: 'price_usd', label: 'price_usd' },
  { id: 'price_diff_pct_1h', label: 'price_diff_pct_1h' },
  { id: 'price_diff_pct_1d', label: 'price_diff_pct_1d' },
  { id: 'volume_usd_1h', label: 'volume_usd_1h' },
  { id: 'volume_usd_24h', label: 'volume_usd_24h' },
  { id: 'circulating_supply', label: 'circulating_supply' },
  { id: 'null', label: 'None' },
];

const STRICT_FILTER_TYPE_OPTIONS = [
  { id: 'token_identifiers', label: 'Token Identifiers' },
  { id: 'chain', label: 'Chain' },
  { id: 'date', label: 'Date Range' },
  { id: 'keywords', label: 'Keywords' },
  { id: 'numeric_filters', label: 'Numeric Filters' },
];

const BOOST_FILTER_TYPE_OPTIONS = [
  { id: 'token_identifiers', label: 'Token Identifiers' },
  { id: 'chain', label: 'Chain' },
  { id: 'date', label: 'Date Range' },
  { id: 'keywords', label: 'Keywords' },
  { id: 'numeric_filters', label: 'Numeric Filters' },
];

const TokenItemsQuery = () => {
  return (
    <QueryModes
      source="token-items"
      sortOptions={SORT_OPTIONS}
      strictFilterTypeOptions={STRICT_FILTER_TYPE_OPTIONS}
      boostFilterTypeOptions={BOOST_FILTER_TYPE_OPTIONS}
    />
  );
};

export default TokenItemsQuery;
